import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui-touch-punch';

/* global SC */

$.fn.Episode = function() {
  let self = this

  if (self.data('episode')) {
    return self.data('episode')
  }

  self.duration = parseInt(self.data('duration'), 10)
  self.player = SC.Widget(self.find('iframe').get(0))
  self.is_playing = false
  self.is_dragging = false

  self.el = {
    play: self.find('button[name="play"]'),
    bar: self.find('.episode__progress-bar'),
    thumb: self.find('.episode__progress-dot'),
  }

  self.play = function() {
    $.mlmi.players.forEach(function(player) {
      if (player != self) {
        player.pause()
      }
    })
    requestAnimationFrame(function() {
      self.player.play()
      self.is_playing = true
      self.addClass('episode--playing')
    })
  }

  self.pause = function() {
    self.player.pause()
    self.removeClass('episode--playing')
    self.is_playing = false
  }

  self.progress = function(e) {
    if (!self.is_dragging) {
      self.el.thumb.css('left', (e.relativePosition * 100) + '%')
    }
  }

  self.finish = function() {
    self.removeClass('episode--playing')
  }

  self.clicked = function() {
    if (self.is_playing) {
      self.pause()
    } else {
      self.play()
    }
  }

  self.start = function() {
    self.is_dragging = true
  }

  self.stop = function() {
    let percent = parseFloat(self.el.thumb.css('left')) / (self.el.bar.outerWidth(false))
    let millisecond = Math.floor(self.duration * percent * 1000)
    self.player.seekTo(millisecond)
    self.is_dragging = false
  }

  self.bar_clicked = function(e) {
    let percent = e.originalEvent.offsetX / (self.el.bar.outerWidth(false))
    let millisecond = Math.floor(self.duration * percent * 1000)
    self.player.seekTo(millisecond)
  }

  return function() {
    self.el.play.on('click', self.clicked)
    self.player.bind(SC.Widget.Events.PLAY_PROGRESS, self.progress)
    self.player.bind(SC.Widget.Events.FINISH, self.finish)
    $(self.el.thumb).draggable({
			axis: 'horizontal',
			containment: self.el.bar,
			start: self.start,
			stop: self.stop
		});
    self.el.bar.on('click', self.bar_clicked)
    self.data('episode', self)
    return self
  }()
}

export default {
  init() {
    $('.episode').each(function() {
      let episode = $(this).Episode()
      $.mlmi.players.push(episode)
    })
  },
}
